import { ChangeDetectorRef, Component} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams, ToastController} from 'ionic-angular';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ApiService } from "../../services/api.service";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { XpUnitPage } from "../xp-unit/xp-unit";
import { XpSearchLocationUnitsPage } from "../xp-search-location-units/xp-search-location-units";
import { XpPickMachinePage } from "../xp-pick-machine/xp-pick-machine";
import { GymDataService, Machine } from "../../services/gym-data.service";
import { XpReportService } from "../../services/xp-report.service";
import { XpReportPage } from "../xp-report/xp-report";

@Component({
  selector: 'page-xp-search-unit',
  templateUrl: 'xp-search-unit.html',
})
export class XpSearchUnitPage {

  busy = false;
  searchPerformed = false;
  searchForm: FormGroup;
  history = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public apiService: ApiService,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScanner,
    public modalCtrl: ModalController,
    public changeDetector: ChangeDetectorRef,
    public gymData: GymDataService,
    public toastCtrl: ToastController,
    public reportService: XpReportService
  ) {
    this.searchForm = this.formBuilder.group({
      code: [''],
      unit_id: ['']
    });
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.searchForm.get('code').setValue(barcode);
        this.search(null);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(history_record){
    this.history = [history_record];
    this.navCtrl.push(XpUnitPage, {
      unit: history_record
    });
  }

  hasActiveSubscription(unit){
    return true;
  }

  searchByCode(code){
    this.searchForm.get('code').setValue(code);
    this.searchForm.get('unit_id').setValue('');
    this.search(null);
  }

  searchByUnitId(unit_id){
    this.searchForm.get('unit_id').setValue(unit_id);
    this.searchForm.get('code').setValue('');
    this.search(null);
  }

  openHistory(history_record){
    this.search(history_record);
  }

  deleteRecord(record){
    this.history = [];
  }

  /**
   * Skip-scan / demo fallback: open the machine picker modal so a user
   * without a printed QR (or in a browser where Cordova BarcodeScanner is
   * silent) can still pick a machine and advance into the flow. Mirrors the
   * web/ machine-picker sheet UX (¿Sin código? Elegí la máquina).
   */
  pickMachineDemo(){
    let modal = this.modalCtrl.create(XpPickMachinePage, {
      machines: this.gymData.machines()
    }, { cssClass: 'modal-pick-machine' });
    modal.onDidDismiss((picked: Machine) => {
      if (!picked) { return; }
      // Package the picked Machine into a unit-shaped object that the
      // downstream report-measurement page can read directly (it pulls
      // unitType / exhaust_type / fuel_type / unit_type off
      // data._selected_units[0]). passport_nr falls back to the machine id
      // so the overview row is never blank; location is a 'demo' stub so
      // the *ngIf="unit.location" overview block still renders.
      let packagedUnit: any = {
        id: picked.id,
        _unit_id: picked.id,
        passport_nr: picked.id,
        qr: picked.qr,
        name: picked.name,
        muscleGroup: picked.muscleGroup,
        equipment: picked.equipment,
        measure: picked.measure,
        unit_model_unit_type: '102',
        unit_type: 'demo',
        fuel_type: '',
        exhaust_type: '',
        list_title: picked.name,
        list_subtitle: picked.muscleGroup,
        location: {
          list_title: 'demo',
          list_subtitle: 'demo',
          street: 'demo',
          number: '',
          zipcode: '',
          city: 'demo',
          country: 'UY'
        }
      };
      // Seed the report envelope the measurement page expects. Mirrors the
      // shape produced by setDummyData() in xp-workorder.service.ts. The
      // service exposes setData() (not a per-field _selected_units setter);
      // see xp-report.service.ts and report-select-unit.ts:102 for the
      // canonical pattern of writing the whole envelope back in one shot.
      let reportData: any = {
        workorder_type: '2',
        workorder_nr: '',
        customers: {
          client: { country: 'UY' },
          invoice: null,
          external: null
        },
        location: packagedUnit.location,
        _selected_units: [packagedUnit],
        reports: [
          { type: 102, reps: 0 }
        ],
        _valid: {},
        _current_report: {}
      };
      this.reportService.setData(reportData);
      // Push into the unit page (so the user sees what they picked) and let
      // the existing flow lead into the report. Mirrors what the real scan
      // path does after a successful resolve. XpReportPage is imported so
      // a future patch can push past XpUnitPage straight into the report.
      this.navCtrl.push(XpUnitPage, { unit: packagedUnit });
    });
    modal.present();
  }

  searchLocationUnits(){
    this.modalCtrl.create(XpSearchLocationUnitsPage, {
      page: this
    }).present();
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter SearchUnitPage');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SearchUnitPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-search-unit/xp-search-unit.ts